import gql from "graphql-tag";

export const GET_AUTHENTICATED_USER = gql`
    query{
        me{
            id
            username
            email
            dateJoined
            profile {
                id
                displayName
                sex
                location
                profession
                workplace
                biography
                websiteUrl
                twitterLink
                facebookLink
                birthday
                phoneNumber
                avatarUrl
            }
            tagFavoriteSet {
                edges {
                    node {
                        id
                        name
                        usageCount
                    }
                }
            }
            postPinnedSet {
                edges {
                    node {
                        id
                    }
                }
            }
        }
    }
`;